import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import styles from './styles.module.less';
import UserDateFormat from '../../../../../components/user-date-timezone-format';
import { TYPE } from '../../constants';
import messages from '../../messages';
import ActionMenu from '../action-menu';

const GridLayout = ({ items, onCopyTemplate, onEditTemplate, onDeleteTemplate }) => {
  return (
    <div
      className={classnames(styles.container, {
        [styles['container-loading']]: !items.length,
      })}
    >
      <div className={styles.header}>
        <FormattedMessage {...messages.gridColName} />
      </div>
      <div className={styles.header}>
        <FormattedMessage {...messages.gridColCreated} />
      </div>
      <div className={styles.header}>
        <FormattedMessage {...messages.gridColLastModifiedDate} />
      </div>
      <div className={styles.header}>
        <FormattedMessage {...messages.gridColLastModified} />
      </div>
      <div className={classnames(styles.header, styles['align-center'])}>
        <FormattedMessage {...messages.gridColActions} />
      </div>
      {!items.length && <LoadingIndicator className={styles.loading} />}
      {items.map((template) => {
        const { name, dateCreated, lastModified, lastModifiedBy, templateId, sellerId } = template;
        return (
          <React.Fragment key={templateId}>
            <div className={styles.cell} title={name}>
              {name}
            </div>
            <div className={styles.cell}>{sellerId ? <UserDateFormat dateTime={dateCreated} /> : null}</div>
            <div className={styles.cell}>{sellerId ? <UserDateFormat dateTime={lastModified} /> : null}</div>
            <div className={styles.cell} title={lastModifiedBy}>
              {sellerId ? lastModifiedBy : null}
            </div>
            <div className={classnames(styles.cell, styles['align-center'])}>
              <ActionMenu
                onCopyTemplate={onCopyTemplate}
                onDeleteTemplate={onDeleteTemplate}
                onEditTemplate={onEditTemplate}
                template={template}
              />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

GridLayout.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      bulkCopyBatchId: PropTypes.string,
      bulkCopyRecordId: PropTypes.string,
      content: PropTypes.string,
      dateCreated: PropTypes.string,
      lastModified: PropTypes.string,
      lastModifiedBy: PropTypes.string,
      locale: PropTypes.string,
      name: PropTypes.string,
      sellerId: PropTypes.string,
      subject: PropTypes.string,
      templateId: PropTypes.string,
      typeId: PropTypes.oneOf([TYPE.SHIPMENT, TYPE.DELIVERY]),
    }),
  ).isRequired,
  onCopyTemplate: PropTypes.func.isRequired,
  onEditTemplate: PropTypes.func.isRequired,
  onDeleteTemplate: PropTypes.func.isRequired,
};

export default GridLayout;
